<template>
  <div>
    <div class="d-flex align-items-end">
      <a
        class="download-link image-link"
        :href="allSystems[3].downloadLink"
        target="_blank"
        rel="noopener noreferrer"
        @click="download(allSystems[3].name)"
      >
        <div class="d-flex justify-content-center mb-3">
          <img
            src="https://dl.intheloop.io/onboarding/android.png"
            alt="logo"
            height="160px"
          />
        </div>
        <img
          height="45px"
          src="https://dl.intheloop.io/onboarding/android_store.png"
          alt="android_store"
        />
      </a>
    </div>
  </div>
</template>

<script>
import newDownload from "@/mixins/newDownload/newDownload";

export default {
  name: "Android",
  mixins: [newDownload],
};
</script>
